import { API_BASE_URL } from '../config/api';
import { withTimezoneOffsetHeader } from './timezoneOffset';

let setIsLoading = null;

export const setLoadingFunction = (loadingFunction) => {
  setIsLoading = loadingFunction;
};

export const apiClient = async (url, options = {}) => {
  if (setIsLoading) setIsLoading(true);
  
  try {
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    const response = await fetch(fullUrl, withTimezoneOffsetHeader(options));
    return response;
  } finally {
    if (setIsLoading) setIsLoading(false);
  }
};